import { NIGHTLIFE_EVENTBRITE_CATEGORY } from '@eventbrite/categories';

export const MOST_POPULAR = 'most_popular';
export const FREE = 'free';
export const THIS_WEEKEND = 'this_weekend';
export const PARTIES = 'parties';
export const VALENTINE = 'valentine';
export const NIGHTLIFE = NIGHTLIFE_EVENTBRITE_CATEGORY;
